/** `-1` is CURRENT — the live row rather than a snapshot. */
export const CURRENT_VERSION_INDEX = -1

/**
 * A version index only means something for the prompt it came from, and the diff dialog stays
 * mounted while the page switches prompts. An index left over from the previous prompt therefore
 * falls back to CURRENT instead of reading past the end of `versions`.
 */
export const versionIndexInRange = (
  index: number,
  versionCount: number
): number =>
  index >= 0 && index < versionCount ? index : CURRENT_VERSION_INDEX

/** Drops the timestamp when a snapshot has none — `Intl` throws on an invalid date. */
export const versionLabel = (
  index: number,
  updatedAt?: string | Date | null
): string => {
  if (index === CURRENT_VERSION_INDEX) return "CURRENT"

  const version = `v${index + 1}${index === 0 ? " (latest)" : ""}`
  const date = new Date(updatedAt ?? "")
  if (Number.isNaN(date.getTime())) return version

  const formatted = new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(date)

  return `${version} (${formatted})`
}
